import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Vehicle } from 'models/Vehicle';

import './VehicleTableCells.styles.scss';

export type VehicleTableConfig = {
  updateInstance: (v: Vehicle) => void;
  instance: Vehicle;
  updateTableData: React.Dispatch<React.SetStateAction<Vehicle[]>>;
};

type VehicleTableCellsProps = {
  className?: string;
  val: any;
  config?: VehicleTableConfig;
};

export const ShowVehicleCell: React.FC<VehicleTableCellsProps> = ({
  className,
  val,
  config,
}) => {
  const {
    instance: { _id: vehicleId },
  } = config;
  const { t } = useTranslation();

  const classes = classNames('show-vehicle-table-cell', className);

  return (
    <div className={classes}>
      <Link to={`${vehicleId}`}>{t('showVehicle')}</Link>
    </div>
  );
};

export const AnnualForecastKilometers: React.FC<VehicleTableCellsProps> = ({
  className,
  val,
  config,
}) => {
  const {
    instance: { annualAgreedKilometers },
  } = config;

  const classes = classNames('forecast-cell', className);

  return (
    <CompareValuesCell
      className={classes}
      value={val}
      refVal={annualAgreedKilometers}
      sufix="km"
    />
  );
};

export const TotalKilometers: React.FC<VehicleTableCellsProps> = ({
  className,
  val,
  config,
}) => {
  const {
    instance: { annualAgreedKilometers },
  } = config;

  const classes = classNames('total-km-cell', className);

  return (
    <CompareValuesCell
      className={classes}
      value={val}
      refVal={annualAgreedKilometers}
      sufix="km"
    />
  );
};

type KilomentersCol = {
  className?: string;
  value: number;
  refVal: number;
  sufix: string;
};

export const CompareValuesCell: React.FC<KilomentersCol> = ({
  className,
  value,
  refVal,
  sufix,
}) => {
  const classes = classNames('kilometers-cell', className, {
    'is-colored': +value > +refVal,
  });

  return (
    <div className={classes}>
      {value} {sufix}
    </div>
  );
};
type DateCmpCell = {
  className?: string;
  value: Date;
  refVal: Date;
};

export const CompareDateCell: React.FC<DateCmpCell> = ({
  className,
  value,
  refVal,
}) => {
  const classes = classNames('kilometers-cell', className, {
    'is-colored': +new Date(value) < +refVal,
  });

  return <div className={classes}>{new Date(value).toLocaleDateString()}</div>;
};
